import { Component } from '@angular/core';
import {provideProtractorTestingSupport} from "@angular/platform-browser";

@Component({
  selector: 'page-menu',
  templateUrl: './page-menu.component.html',
  styleUrls: ['./page-menu.component.less']
})
export class PageMenuComponent {

  cc = "Искусство детям"
  hh = "/home/natasha/Pictures/image_2023-12-18_11-1фыв4-09 (ыы2).png"

}
